import React, { useState, useEffect } from 'react';
import { Select, DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const ReportDateFilter = ({ dates, onChange, style = {} }) => {
  const currentYear = dayjs().year();
  const [dateMode, setDateMode] = useState('current_year');
  const [selectedFYYear, setSelectedFYYear] = useState(dayjs());
  const [selectedCYYear, setSelectedCYYear] = useState(dayjs());

  useEffect(() => {
    // If the user explicitly picked Financial Year or Calendar Year, preserve that mode
    if (dateMode === 'cy' || dateMode === 'fy') {
      return;
    }

    if (!dates || (!dates[0] && !dates[1])) {
      setDateMode('current_year');
    } else if (dates[0] && dates[1]) {
      const yr = dayjs().year();
      if (dates[0].isSame(dayjs(`${yr}-01-01`), 'day') && dates[1].isSame(dayjs(`${yr}-12-31`), 'day')) {
        setDateMode('current_year');
      } else if (dates[0].isSame(dayjs(`${yr - 1}-01-01`), 'day') && dates[1].isSame(dayjs(`${yr - 1}-12-31`), 'day')) {
        setDateMode('last_year');
      } else {
        setDateMode('custom');
      }
    }
  }, [dates]);

  const handleDateModeChange = (modeVal) => {
    setDateMode(modeVal);
    if (modeVal === 'current_year') {
      onChange([dayjs(`${currentYear}-01-01`), dayjs(`${currentYear}-12-31`)]);
    } else if (modeVal === 'last_year') {
      const ly = currentYear - 1;
      onChange([dayjs(`${ly}-01-01`), dayjs(`${ly}-12-31`)]);
    } else if (modeVal === 'fy') {
      const yr = selectedFYYear ? selectedFYYear.year() : currentYear;
      onChange([dayjs(`${yr}-04-01`), dayjs(`${yr + 1}-03-31`)]);
    } else if (modeVal === 'cy') {
      const yr = selectedCYYear ? selectedCYYear.year() : currentYear;
      onChange([dayjs(`${yr}-01-01`), dayjs(`${yr}-12-31`)]);
    } else if (modeVal === 'custom') {
      if (!dates) {
        onChange([dayjs(`${currentYear}-01-01`), dayjs(`${currentYear}-12-31`)]);
      }
    }
  };

  const handleFYYearChange = (val) => {
    const yearObj = val || dayjs();
    setSelectedFYYear(yearObj);
    const yr = yearObj.year();
    onChange([dayjs(`${yr}-04-01`), dayjs(`${yr + 1}-03-31`)]);
  };

  const handleCYYearChange = (val) => {
    const yearObj = val || dayjs();
    setSelectedCYYear(yearObj);
    const yr = yearObj.year();
    onChange([dayjs(`${yr}-01-01`), dayjs(`${yr}-12-31`)]);
  };

  return (
    <div className="d-flex align-items-center gap-2" style={style}>
      <Select
        value={dateMode}
        onChange={handleDateModeChange}
        style={{ width: 140 }}
        size="middle"
      >
        <Select.Option value="current_year">Current Year</Select.Option>
        <Select.Option value="last_year">Last Year</Select.Option>
        <Select.Option value="fy">Financial Year</Select.Option>
        <Select.Option value="cy">Calendar Year</Select.Option>
        <Select.Option value="custom">Custom</Select.Option>
      </Select>

      {dateMode === 'fy' && (
        <DatePicker
          picker="year"
          placeholder="Select FY"
          value={selectedFYYear}
          onChange={handleFYYearChange}
          size="middle"
          style={{ width: 120 }}
          format={(val) => (val ? `FY ${val.year()}-${(val.year() + 1).toString().slice(-2)}` : '')}
          allowClear={false}
        />
      )}

      {dateMode === 'cy' && (
        <DatePicker
          picker="year"
          placeholder="Select Year"
          value={selectedCYYear}
          onChange={handleCYYearChange}
          size="middle"
          style={{ width: 110 }}
          format={(val) => (val ? `${val.year()}` : '')}
          allowClear={false}
        />
      )}

      {dateMode === 'custom' && (
        <RangePicker
          value={dates}
          onChange={(val) => onChange(val)}
          style={{ width: 250 }}
          size="middle"
          allowClear
        />
      )}
    </div>
  );
};

export default ReportDateFilter;

